import { SharedLanguageService } from '@language';

import { ColumnDef } from '../../record/entities/column-definition.entity';
import { ColumnWidth } from '../../record/entities/column-width.entity';
import { Column } from '../../record/entities/column.entity';
import { ReportRow } from '../entities/report-row.entity';
import { ReportColumn } from '../services/reports-column-handler.service';

export function toReportColumns(translate: SharedLanguageService): Column<ReportRow>[] {
    return [
        new ColumnDef<ReportRow>({
            key: ReportColumn.Naam,
            label: translate.instant('reports.table.columns.name'),
            width: ColumnWidth.EXTRAWIDE
        })
    ].map(columnDefinition => ({ columnDefinition }));
}
